import React from 'react'

import Main from '@/components/misc/Main'
import SentryErrorBoundary from '@/components/misc/SentryErrorBoundary'

interface Props {
  children: React.ReactNode
}

const LandingDarkLayout: React.FC<Props> = ({ children }) => (
  <Main
    className="bg-black pb-4"
    style={{
      backgroundImage: 'linear-gradient(145deg, #2a3141, #1a6aac',
      backgroundAttachment: 'fixed',
    }}
  >
    <style>
      {/* Because just putting it on main means the overscroll on Mac/iPhone is still white */}
      {'body { background-color: #2a3141; }'}
    </style>
    <SentryErrorBoundary variant="full-screen">{children}</SentryErrorBoundary>
  </Main>
)

export default LandingDarkLayout
